export function StringToFormattedString(str: string): string {
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function NumberToFormattedString(n: number): string {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function ordinalNumber(n: number): string {
  if (n > 3 && n < 21) {
    return n + 'th';
  }
  if (n % 10 === 1) {
    return n + 'st';
  }
  if (n % 10 === 2) {
    return n + 'nd';
  }
  if (n % 10 === 3) {
    return n + 'rd';
  }
  return n + 'th';
}
